import React from "react";
import {Container} from "react-bootstrap";
import ImageGallery from 'react-image-gallery';
import { Row, Col } from "react-bootstrap";

const activity_images = [
    {
        original: '/image/gallery/activity/3.jpg',
        thumbnail: '/image/gallery/activity/3.jpg',
        description: '2023 Research team team-building',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/4.jpg',
        thumbnail: '/image/gallery/activity/4.jpg',
        description: '2022 Research team team-building',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/5.jpg',
        thumbnail: '/image/gallery/activity/5.jpg',
        description: '2022 Research team team-building',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/6.jpg',
        thumbnail: '/image/gallery/activity/6.jpg',
        description: 'Professor Zhao\'s first Teacher\'s Day',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/9.jpg',
        thumbnail: '/image/gallery/activity/9.jpg',
        description: 'Stephen J. Pennycook visited the research team.',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/10.jpg',
        thumbnail: '/image/gallery/activity/10.jpg',
        description: 'Stephen J. Pennycook visited the research team.',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/11.jpg',
        thumbnail: '/image/gallery/activity/11.jpg',
        description: 'Professor Loh Kian Ping visited and exchanged ideas at the School of Materials Science and Engineering at Peking University.',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/12.jpg',
        thumbnail: '/image/gallery/activity/12.jpg',
        description: 'Stephen J. Pennycook visited the research team.',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/13.jpg',
        thumbnail: '/image/gallery/activity/13.jpg',
        description: 'Stephen J. Pennycook visited the research team.',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/14.jpg',
        thumbnail: '/image/gallery/activity/14.jpg',
        description: 'Belarusian international students visiting for exchange\n',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/15.jpg',
        thumbnail: '/image/gallery/activity/15.jpg',
        description: '2024 Research team team-building',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/activity/16.jpg',
        thumbnail: '/image/gallery/activity/16.jpg',
        description: '2025 Research team team-building',
        originalHeight: '768px',
        originalWidth: '1080px',
    }
];

const facility_images = [
    {
        original: '/image/gallery/facility/1.jpg',
        thumbnail: '/image/gallery/facility/1.jpg',
        description: 'JEM-ARM300F2',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/facility/2.jpg',
        thumbnail: '/image/gallery/facility/2.jpg',
        description: 'JEM-F200',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/facility/3.jpg',
        thumbnail: '/image/gallery/facility/3.jpg',
        description: 'Regulus8220',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/facility/4.jpg',
        thumbnail: '/image/gallery/facility/4.jpg',
        description: 'Tescan-solaris',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/facility/5.jpg',
        thumbnail: '/image/gallery/facility/5.jpg',
        description: 'FEI-Titan Krios\n',
        originalHeight: '768px',
        originalWidth: '1080px',
    },
    {
        original: '/image/gallery/facility/6.jpg',
        thumbnail: '/image/gallery/facility/6.jpg',
        description: 'JEM-ARM200F NEOARM',
        originalHeight: '768px',
        originalWidth: '1080px',
    }
]

// function MyGallery() {
//     return (
//         <section>
//         <Container fluid className={"project-section"}>
//             <h1 className={"white-text"}>Gallery</h1>
//         </Container>
//         <Container fluid className={"gallery-section"}>
//             <ImageGallery items={images} />
//         </Container>
//         </section>
//     )
// }


// function MyGallery() {
//     return (
//         <section>
//             <Container fluid className={"project-section"}>
//                 <h1 className={"white-text"}>Gallery</h1>
//             </Container>
//             <Container fluid className={"gallery-section"}>
//                 <Row>
//                     <Col md={6}>
//                         <h2 className={"white-text"}>Gallery Part 1</h2>
//                         <ImageGallery items={facility_images} />
//                     </Col>
//                     <Col md={6}>
//                         <h2 className={"white-text"}>Gallery Part 2</h2>
//                         <ImageGallery items={activity_images} />
//                     </Col>
//                 </Row>
//             </Container>
//         </section>
//     );
// }

function MyGallery() {
    return (
        <section>
            <Container fluid className={"project-section"}>
                <h1 className={"white-text"}>Gallery</h1>
            </Container>
            <Container fluid className={"gallery-section"}>
                <div className="gallery-part">
                    <h2 className={"text-black"}>Facility</h2>
                    <ImageGallery items={facility_images} />
                </div>
                <div className="gallery-part" style={{ marginTop: '40px' }}>
                    <h2 className={"text-black"}>Activity</h2>
                    <ImageGallery items={activity_images} />
                </div>
            </Container>
        </section>
    );
}
export default MyGallery;